<template>
  <v-dialog
    :value="showDialog"
    @input="closeDialog()"
    content-class="showDialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    max-width="950px"
    style="z-index: 9999"
  >
    <v-card class="custom-tooltips">
      <v-card-title style="justify-content:center">
        <span v-html="matchTitle" class="headline"></span>
        <v-btn @click="closeDialog()" icon absolute right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        ref="modalContent"
        v-if="obj.tooltip_new && !obj.description_new"
        v-html="obj.tooltip_new"
        class="no-top-padding padding-bottom-tooltips overflow-hidden-x"
      ></v-card-text>
      <v-card-text
        ref="modalContent"
        v-else-if="obj.tooltip && !obj.description"
        v-html="obj.tooltip"
        class="no-top-padding padding-bottom-tooltips overflow-hidden-x"
      ></v-card-text>
      <v-card-text
        ref="modalContent"
        v-if="obj.description_new && !obj.tooltip_new"
        v-html="obj.description_new"
        class="no-top-padding padding-bottom-tooltips overflow-hidden-x"
      ></v-card-text>
      <v-card-text
        ref="modalContent"
        v-else-if="obj.description && !obj.tooltip"
        v-html="obj.description"
        class="no-top-padding padding-bottom-tooltips overflow-hidden-x"
      ></v-card-text>
      <div v-if="isCustomBottom" class="reg-go">
        <div v-if="objCustom.text" v-html="objCustom.text"></div>
        <v-btn
          :href="objCustom.url"
          v-html="objCustom.btn"
          target="_new"
          class="tooltip-btn tooltip-btn-bg min-width-170"
        ></v-btn>
      </div>
      <div v-else-if="isMoneyBottom" class="reg-go">
        <div
          v-if="User.isLogged"
          style="text-align: center;max-width:250px;padding-top:15px"
        >
          <v-btn
            v-if="User.user_products_id"
            @click="
              shareReport(User.user_products_id, User.is_user_product_hash)
            "
            class="tooltip-btn tooltip-btn-bg"
            style="background:linear-gradient(90deg,#00ba88,#196ad6);margin-right:4px;width:48%"
            >Начать</v-btn
          >
          <v-btn
            v-else
            @click="shareReport(User.reportid, User.is_user_product_hash)"
            class="tooltip-btn tooltip-btn-bg"
            style="background:linear-gradient(90deg,#00ba88,#196ad6);margin-right:4px;width:48%"
            >Начать</v-btn
          >
          <v-btn
            href="/#/profile"
            target="_new"
            class="tooltip-btn tooltip-btn-bg"
            style="width:48%"
            >Кабинет</v-btn
          >
        </div>
        <div v-else style="text-align: center">
          <div v-html="RegGoTextBeforeBtn"></div>
          <div
            v-if="
              !User.isLogged &&
                $route.path !== '/composite' &&
                $route.path !== '/transit' &&
                $route.path !== '/returns'
            "
            class="flex-center"
          >
            <!-- <v-btn
              @click="callToAppEvents(2)"
              :href="User.tgBotUrl"
              target="_blank"
              v-html="getMessage('btn_tg_tooltip_normal')"
              class="tooltip-btn-bg mob-tooltip-btn-bg"
            ></v-btn>
            &nbsp;&nbsp;
            <v-btn
              @click="clickTooltipBtnBG(extTips)"
              v-html="getMessage(btnTooltipName)"
              class="tooltip-btn-bg mob-tooltip-btn-bg"
            ></v-btn> -->
            <v-btn
              @click="clickTooltipBtnBG(extTips)"
              v-html="getMessage(btnTooltipName)"
              class="tooltip-btn-bg mob-tooltip-btn-bg"
            ></v-btn>
          </div>
          <v-btn
            v-else
            @click="clickTooltipBtnBG(extTips)"
            v-html="getMessage(btnTooltipName)"
            class="tooltip-btn-bg mob-tooltip-btn-bg"
          ></v-btn>
        </div>
      </div>
      <div v-else class="reg-go">
        <div v-html="RegGoTextBeforeBtn"></div>
        <div
          v-if="
            !User.isLogged &&
              $route.path !== '/composite' &&
              $route.path !== '/transit' &&
              $route.path !== '/returns'
          "
          class="flex-center"
        >
          <!-- <v-btn
            @click="callToAppEvents(2)"
            :href="User.tgBotUrl"
            target="_blank"
            v-html="getMessage('btn_tg_tooltip_normal')"
            class="tooltip-btn-bg mob-tooltip-btn-bg"
          ></v-btn>
          &nbsp;&nbsp;
          <v-btn
            @click="clickTooltipBtnBG(extTips)"
            v-html="getMessage(btnTooltipName)"
            class="tooltip-btn-bg mob-tooltip-btn-bg"
          ></v-btn> -->
          <v-btn
            @click="clickTooltipBtnBG(extTips)"
            v-html="getMessage(btnTooltipName)"
            class="tooltip-btn-bg mob-tooltip-btn-bg"
          ></v-btn>
        </div>
        <v-btn
          v-else
          @click="clickTooltipBtnBG(extTips)"
          v-html="getMessage(btnTooltipName)"
          class="tooltip-btn-bg mob-tooltip-btn-bg"
        ></v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { commonInitAppMethods } from "@/mixins/common-init-app-methods";
import { commonReportingMethods } from "@/mixins/common-reporting-methods";

export default {
  name: "TooltipDiaolog",
  mixins: [commonInitAppMethods, commonReportingMethods],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: null
    },
    objCustom: {
      type: Object,
      default: null
    },
    isCustomBottom: {
      type: Boolean,
      default: false
    },
    isMoneyBottom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { show: false };
  },
  computed: {
    ...mapState({
      User: (state) => state.account.User,
      Composite: (state) => state.account.Composite,
      Transit: (state) => state.account.Transit,
      Infliction: (state) => state.account.Infliction,
      Return: (state) => state.account.Return
    }),
    firstname: {
      get() {
        return this.$store.state.account.User.name;
      },
      set(value) {
        this.$store.commit("account/update_name", value);
      }
    },
    matchTitle() {
      return this.obj.icon
        ? `<span style="color:${
            this.$store.state.account.User.gexagrammColor[this.obj.gate]
          }
          ">${this.obj.icon}</span> ${this.obj.title}`
        : this.obj.icon_class
        ? `<span class="center-icons ${this.obj.icon_class}"></span>&nbsp;${this.obj.title}`
        : this.obj.title;
    },
    RegGoTextBeforeBtn() {
      return this.$route.path === "/bodygraph" ||
        this.$route.path === "/transit" ||
        this.$route.path === "/returns"
        ? this.$store.state.account.User.RegGoTextBeforeBtn
        : this.$route.path === "/composite"
        ? this.$store.state.account.User.RegGoTextBeforeBtnComposite
        : "";
    },
    btnTooltipName() {
      return this.$route.path === "/bodygraph" ||
        this.$route.path === "/transit" ||
        this.$route.path === "/returns"
        ? this.$store.state.account.User.btnTooltipName
        : this.$route.path === "/composite"
        ? this.$store.state.account.User.btnTooltipNameComposite
        : "";
    },
    extTips() {
      return this.$store.state.conf.ConfApp.isBuyedProTooltips;
    }
  },
  beforeMount() {
    window.openLoginDialog = this.openLoginDialog;
    window.enableFullTooltips = this.enableFullTooltips;
  },
  methods: {
    ...mapMutations({
      update_login_dialog: "conf/update_login_dialog",
      request_full_tooltips_on: "conf/request_full_tooltips_on"
    }),
    clickTooltipBtnBG(extTips, isInfoBlockExtTips) {
      if (this.$route.path === "/bodygraph") {
        const SHOP_URL =
          extTips === "ext_tips"
            ? this.$store.state.conf.ConfApp.tooltips_buy_full_url
            : extTips
            ? this.$store.state.conf.ConfApp.tooltips_shop_url
            : this.$store.state.conf.ConfApp.tooltips_sale_shop_url;
        switch (this.$store.state.conf.ConfApp.tooltip_button_type) {
          case 1:
            if (isInfoBlockExtTips) {
              const URL = SHOP_URL + "&tag=r" + this.User.reportid;
              window.open(URL, "_blank");
            } else {
              this.closeDialog();
              this.update_login_dialog(true);
            }
            break;
          case 2:
            this.$router.push("/profile");
            break;
          case 3: {
            // this.$router.push("/products");
            const URL3 = this.$store.state.conf.ConfApp.pdfs_shop_url;
            window.open(URL3, "_blank");
            break;
          }
          case 4: {
            const URL4 = SHOP_URL + "&tag=r" + this.User.reportid;
            window.open(URL4, "_blank");
            break;
          }
          case 6: {
            // Здесь сейчас показываются всегда FULL-подсказки
            console.log("SHOP_URL: ", SHOP_URL);
            const SHOP_URL6 = this.$store.state.conf.ConfApp
              .tooltips_buy_full_url;
            const URL6 = SHOP_URL6 + "&tag=r" + this.User.reportid;
            window.open(URL6, "_blank");
            break;
          }
          case 7:
            // FULL-подсказки выключены, предложение включить
            this.$router.push("/profile");
            break;
          case 8: {
            // Если приходит 8, то в бодиграфе предлагаются демо-расшифровки
            const url8 = this.$store.state.conf.ConfApp.demo_report_shop_url;
            window.open(url8, "_blank");
            break;
          }
          case 9: {
            // Если приходит 9, то в бодиграфе предлагается купить 1 демо-расшифровку
            const url9 =
              this.$store.state.conf.ConfApp.one_report_tooltips_url +
              "&tag=r" +
              this.User.reportid;
            window.open(url9, "_blank");
            break;
          }
          default:
            if (this.User.isLogged) {
              // реклама партнерки по дифолту (отключена)
              /* this.$store.commit(
                "account/set_partner_info_text",
                this.getMessage("partners")
              );
              this.$store.commit("account/call_partner_dialog"); */
              // по дифолту для авторизованных юзеров сейчас переход на покупку PDF
              const URL = this.$store.state.conf.ConfApp.pdfs_shop_url;
              window.open(URL, "_blank");
            } else {
              this.closeDialog();
              this.update_login_dialog(true);
            }
            break;
        }
      } else if (this.$route.path === "/composite") {
        switch (this.$store.state.conf.ConfApp.cp_tooltip_button_type) {
          case 1:
            this.closeDialog();
            this.update_login_dialog(true);
            break;
          case 2:
            this.$router.push("/profile");
            break;
          case 3:
            this.$router.push("/products");
            break;
          case 4: {
            const SHOP_URL4 = extTips
              ? this.$store.state.conf.ConfApp.tooltips_shop_url
              : this.$store.state.conf.ConfApp.tooltips_sale_shop_url;
            const url4 = SHOP_URL4 + "&tag=r" + this.User.reportid;
            window.open(url4, "_blank");
            break;
          }
          case 5: {
            const url5 =
              this.$store.state.conf.ConfApp.composite_shop_url +
              "&tag=r" +
              this.User.reportid;
            window.open(url5, "_blank");
            break;
          }
          case 6: {
            /* const SHOP_URL6 =
                extTips ||
                extTips === 'ext_tips' ||
                this.User.full_tooltips_count
                  ? this.$store.state.ConfApp.tooltips_buy_full_url
                  : this.$store.state.ConfApp.tooltips_shop_url */
            // Если приходит 6, то в композите предлагаются только расширенные
            const SHOP_URL6 = this.$store.state.conf.ConfApp
              .tooltips_buy_full_url;
            const url6 = SHOP_URL6 + "&tag=r" + this.User.reportid;
            window.open(url6, "_blank");
            break;
          }
          case 7:
            // FULL-подсказки выключены, предложение включить
            this.$router.push("/profile");
            break;
          case 8: {
            // Если приходит 8, то в бодиграфе предлагаются демо-расшифровки
            const url8 = this.$store.state.conf.ConfApp.demo_report_shop_url;
            window.open(url8, "_blank");
            break;
          }
          default: {
            if (this.User.isLogged) {
              // реклама партнерки по дифолту (отключена)
              /* this.$store.commit(
                "account/set_partner_info_text",
                this.getMessage("partners")
              );
              this.$store.commit("account/call_partner_dialog"); */
              // по дифолту для авторизованных юзеров сейчас переход на покупку PDF
              const URL = this.$store.state.conf.ConfApp.pdfs_shop_url;
              window.open(URL, "_blank");
            } else {
              this.update_login_dialog(true);
            }
            break;
          }
        }
      } else if (
        this.$route.path === "/transit" ||
        this.$route.path === "/returns"
      ) {
        /* console.log(
          "tooltip_button_type: ",
          this.$store.state.conf.ConfApp.tooltip_button_type
        ); */
        switch (this.$store.state.conf.ConfApp.tooltip_button_type) {
          case 1: {
            // this.closeDialog();
            // this.update_login_dialog(true);
            // Hardcode — предлагается PDF-отчет
            const URL = this.$store.state.conf.ConfApp.pdfs_shop_url;
            window.open(URL, "_blank");
            break;
          }
          case 2:
            this.$router.push("/profile");
            break;
          case 3:
            this.$router.push("/products");
            break;
          case 4: {
            const SHOP_URL4 = extTips
              ? this.$store.state.conf.ConfApp.tooltips_shop_url
              : this.$store.state.conf.ConfApp.tooltips_sale_shop_url;
            const url4 = SHOP_URL4 + "&tag=r" + this.User.reportid;
            window.open(url4, "_blank");
            break;
          }
          case 5: {
            const url5 =
              this.$store.state.conf.ConfApp.composite_shop_url +
              "&tag=r" +
              this.User.reportid;
            window.open(url5, "_blank");
            break;
          }
          case 6: {
            // Если приходит 6, то предлагаются PDF-отчет
            const SHOP_URL6 = this.$store.state.conf.ConfApp.tooltips_shop_url;
            const url6 = SHOP_URL6 + "&tag=r" + this.User.reportid;
            window.open(url6, "_blank");
            break;
          }
          case 7:
            // FULL-подсказки выключены, предложение включить
            this.$router.push("/profile");
            break;
          case 8: {
            // Если приходит 8, то в бодиграфе предлагаются демо-расшифровки
            const url8 = this.$store.state.conf.ConfApp.demo_report_shop_url;
            window.open(url8, "_blank");
            break;
          }
          default:
            if (this.User.isLogged) {
              // реклама партнерки по дифолту (отключена)
              /* this.$store.commit(
                "account/set_partner_info_text",
                this.getMessage("partners")
              );
              this.$store.commit("account/call_partner_dialog"); */
              // по дифолту для авторизованных юзеров сейчас переход на покупку PDF
              const URL = this.$store.state.conf.ConfApp.pdfs_shop_url;
              window.open(URL, "_blank");
            } else {
              this.closeDialog();
              this.update_login_dialog(true);
            }
            break;
        }
      }
    },
    shareReport(id, userProduct) {
      const data = { id, userProduct };
      this.$store.dispatch("account/shareReport", data);
    },
    openLoginDialog() {
      this.update_login_dialog(true);
    },
    closeDialog() {
      this.$refs.modalContent.scrollTop = 0;
      this.$emit("closeTooltipDialog");
    },
    async enableFullTooltips() {
      const endPoint = this.User.user_products_id
        ? "account/getReportFromUserProductById"
        : this.Composite.report_id && this.$route.path === "/composite"
        ? "account/getCompositeReportById"
        : this.Infliction.report_id && this.$route.path === "/transit"
        ? "account/getInflictionReportById"
        : this.Transit.report_id && this.$route.path === "/transit"
        ? "account/getTransitReportById"
        : this.Return.report_id && this.$route.path === "/returns"
        ? "account/getReturnReportById"
        : "account/getRaveReportById";
      const reportId = this.User.user_products_id
        ? this.User.user_products_id
        : this.Composite.report_id && this.$route.path === "/composite"
        ? this.Composite.report_id
        : this.Infliction.report_id && this.$route.path === "/transit"
        ? this.Infliction.report_id
        : this.Transit.report_id && this.$route.path === "/transit"
        ? this.Transit.report_id
        : this.Return.report_id && this.$route.path === "/returns"
        ? this.Return.report_id
        : this.User.reportid;
      const successResult = await this.$store.dispatch(endPoint, {
        id: reportId,
        isFullTooltips: true
      });
      if (successResult) {
        // console.log("successResult: ", successResult);
        this.closeDialog();
        this.request_full_tooltips_on();
      }
    }
  }
};
</script>
